<template>
  <el-dialog
    :title="title"
    :visible="visible"
    :width="dialogWidth"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <!-- 添加el-form容器，绑定model和rules -->
    <el-form
      ref="deviceForm"
      :model="formData"
      :rules="rules"
      label-width="0"
      class="device-form"
    >
      <!-- 表头 -->
      <el-row class="table-header" :gutter="10">
        <el-col :span="3"><span class="required">*</span>创建时间</el-col>
        <el-col :span="3"
          ><span class="required">*</span>设备名称(设备ID)</el-col
        >
        <!-- <el-col :span="3"><span class="required">*</span>设备ID</el-col> -->
        <el-col :span="4"><span class="required">*</span>状态</el-col>
        <el-col :span="2"><span class="required">*</span>设备温度(℃)</el-col>
        <el-col :span="2"><span class="required">*</span>压力(kPa)</el-col>
        <el-col :span="2"><span class="required">*</span>工作时间(s)</el-col>
        <el-col :span="2"><span class="required">*</span>工作面积(m²)</el-col>
        <el-col :span="2"><span class="required">*</span>海拔高度(m)</el-col>
        <el-col :span="2"
          ><span class="required">*</span>经纬度(经度,纬度)</el-col
        >
        <!-- <el-col :span="2"><span class="required"></span>设备图片</el-col> -->
        <el-col :span="2">操作</el-col>
      </el-row>

      <!-- 数据行（循环渲染） -->
      <div class="table-body">
        <el-row
          v-for="(row, index) in formData.tableRows"
          :key="index"
          class="table-row"
          :gutter="10"
        >
          <!-- 接收时间（必填，日期时间类型） -->
          <el-col :span="3">
            <el-form-item
              :prop="'tableRows.' + index + '.create_time'"
              :rules="rules.create_time"
            >
              <el-date-picker
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                v-model="row.create_time"
                type="datetime"
                placeholder="选择日期时间"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>

          <!-- 设备名称（必填，文本类型） -->
          <el-col :span="3">
            <el-form-item
              :prop="'tableRows.' + index + '.device_name'"
              :rules="rules.device_name"
            >
              <!-- <el-input v-model="row.device_name" placeholder="请输入"></el-input> -->
              <el-select
                v-model="row.device_name"
                value-key="id"
                placeholder="请选择"
                clearable
                filterable
                @change="(v) => selectChange(v, row)"
              >
                <el-option
                  v-for="itemC in selectOptions"
                  :key="itemC.id"
                  :label="itemC.device_name"
                  :value="itemC"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <!-- 设备ID（必填，文本类型） -->
          <!-- <el-col :span="3">
            <el-form-item
              :prop="'tableRows.' + index + '.device_id'"
              :rules="rules.device_id"
            >
              <el-input v-model="row.device_id" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col> -->

          <!-- 运行状态（必填，单选类型） -->
          <el-col :span="4">
            <el-form-item
              :prop="'tableRows.' + index + '.status'"
              :rules="rules.status"
            >
              <el-radio-group v-model="row.status">
                <el-radio :label="'1'">运行</el-radio>
                <el-radio :label="'2'">待机</el-radio>
                <el-radio :label="'3'">离线</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>

          <!-- 设备温度（必填，数字类型） -->
          <el-col :span="2">
            <el-form-item
              :prop="'tableRows.' + index + '.temperature'"
              :rules="rules.temperature"
            >
              <el-input
                v-model.number="row.temperature"
                placeholder="请输入数字"
                type="number"
              ></el-input>
            </el-form-item>
          </el-col>

          <!-- 压力（必填，数字类型） -->
          <el-col :span="2">
            <el-form-item
              :prop="'tableRows.' + index + '.pressure'"
              :rules="rules.pressure"
            >
              <el-input
                v-model.number="row.pressure"
                placeholder="请输入数字"
                type="number"
              ></el-input>
            </el-form-item>
          </el-col>

          <!-- 工作时间（必填，数字类型） -->
          <el-col :span="2">
            <el-form-item
              :prop="'tableRows.' + index + '.accumulated_time'"
              :rules="rules.accumulated_time"
            >
              <el-input
                v-model.number="row.accumulated_time"
                placeholder="请输入数字"
                type="number"
              ></el-input>
            </el-form-item>
          </el-col>

          <!-- 工作面积（必填，数字类型） -->
          <el-col :span="2">
            <el-form-item
              :prop="'tableRows.' + index + '.work_count'"
              :rules="rules.work_count"
            >
              <el-input
                v-model.number="row.work_count"
                placeholder="请输入数字"
                type="number"
              ></el-input>
            </el-form-item>
          </el-col>

          <!-- 海拔高度（必填，数字类型） -->
          <el-col :span="2">
            <el-form-item
              :prop="'tableRows.' + index + '.altitude'"
              :rules="rules.altitude"
            >
              <el-input
                v-model.number="row.altitude"
                placeholder="请输入数字"
                type="number"
              ></el-input>
            </el-form-item>
          </el-col>

          <!-- 经纬度（必填，自定义格式验证） -->
          <el-col :span="2">
            <el-form-item
              :prop="'tableRows.' + index + '.location'"
              :rules="rules.location"
            >
              <el-input
                v-model="row.location"
                placeholder="(12.11,30.456)"
              ></el-input>
            </el-form-item>
          </el-col>

          <!-- 设备图片（必填，自定义验证） -->
          <!-- <el-col :span="2">
                        <el-form-item style="margin: 0;" :prop="'tableRows.' + index + '.imageUrl'"
                            :rules="rules.imageUrl">
                            <el-upload ref="upload" :accept="exts.map(r => '.' + r).join(',')" action="#"
                                :auto-upload="false" :on-change="(a, b) => handleChange(a, b, row)"
                                :show-file-list="false" :multiple="false">
                                <el-button type="text" v-if="row.imageUrl == ''">选择图片</el-button>
                                <img v-else style="width: 60px; height: 60px" :src="row.imageUrl" />
                            </el-upload>
                        </el-form-item>
                    </el-col> -->

          <!-- 新增行按钮 -->
          <el-col :span="2">
            <el-button
              type="danger"
              icon="el-icon-minus"
              v-if="index != 0"
              circle
              size="small"
              @click="delRow(index)"
            ></el-button>
            <el-button
              type="primary"
              v-if="index == 0"
              icon="el-icon-plus"
              circle
              size="small"
              @click="addRow"
            ></el-button>
          </el-col>
        </el-row>
      </div>

      <!-- 底部按钮 -->
      <div class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确定</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  name: "DeviceInfoDialog",
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: "设备信息录入" },
    dialogWidth: { type: String, default: "90%" },
    initialData: { type: Array, default: () => [] },
    selectOptions: { required: true, type: Array, default: () => [] },
    datatype: { type: String, default: "1" },
  },
  data() {
    // 自定义经纬度验证规则（格式：数字,数字）
    const validateCoordinate = (rule, value, callback) => {
      const reg = /^-?\d+(\.\d+)?,-?\d+(\.\d+)?$/;
      if (!value) {
        callback(new Error("请输入经纬度"));
      } else if (!reg.test(value)) {
        callback(new Error("格式错误（例：120.123,30.456）"));
      } else {
        callback();
      }
    };

    // 自定义图片验证规则（必须选择图片）
    const validateImage = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请选择图片"));
      } else {
        callback();
      }
    };

    return {
      exts: ["jpg", "jpeg", "png"], // 允许上传的图片格式
      // 表单数据（包含多行数据）
      formData: {
        tableRows: [],
      },
      // 验证规则
      rules: {
        create_time: [
          { required: true, message: "请选择接收时间", trigger: "change" },
        ],
        device_name: [
          { required: true, message: "请输入设备名称", trigger: "change" },
        ],
        // device_id: [
        //   { required: true, message: "请输入设备ID", trigger: "blur" },
        // ],
        status: [
          { required: true, message: "请选择运行状态", trigger: "change" },
        ],
        temperature: [
          { required: true, message: "请输入设备温度", trigger: "blur" },
          { type: "number", message: "请输入有效数字", trigger: "blur" },
        ],
        pressure: [
          { required: true, message: "请输入压力", trigger: "blur" },
          { type: "number", message: "请输入有效数字", trigger: "blur" },
        ],
        accumulated_time: [
          { required: true, message: "请输入工作时间", trigger: "blur" },
          { type: "number", message: "请输入有效数字", trigger: "blur" },
        ],
        work_count: [
          { required: true, message: "请输入工作面积", trigger: "blur" },
          { type: "number", message: "请输入有效数字", trigger: "blur" },
        ],
        altitude: [
          { required: true, message: "请输入海拔高度", trigger: "blur" },
          { type: "number", message: "请输入有效数字", trigger: "blur" },
        ],
        location: [
          { required: true, trigger: "blur", validator: validateCoordinate },
        ],
        // imageUrl: [
        //     { required: true, trigger: 'change', validator: validateImage }
        // ]
      },
    };
  },
  watch: {
    visible(val) {
      if (val) this.initFormData();
    },
  },
  methods: {
    delRow(index) {
      this.formData.tableRows.splice(index, 1);
    },
    selectChange(value, item) {
      item.device_id = value.device_id;
      item.device_name = value.device_name;
    },
    handleChange(file, fileList, row) {
      var ext = file.name
        .substring(file.name.lastIndexOf(".") + 1)
        .toLowerCase();
      if (!this.exts.includes(ext)) {
        this.$message.error("请上传正确的文件格式");
      } else {
        row.imageUrl = URL.createObjectURL(file.raw);
        row.file = file.raw;
        console.log(row);
      }
    },
    // 初始化表单数据
    initFormData() {
      this.formData.tableRows =
        this.initialData.length > 0
          ? this.initialData.map((row) => ({
              ...row,
              status: row.status || "运行",
            }))
          : [this.getDefaultRow()];
    },

    // 默认行数据
    getDefaultRow() {
      return {
        create_time: "",
        // imageUrl: '',
        device_id: "",
        device_name: "",
        status: "1",
        location: "",
        work_count: "",
        altitude: "",
        temperature: "",
        pressure: "",
        accumulated_time: "",
        datatype: 1,
      };
    },

    // 添加新行
    addRow() {
      this.formData.tableRows.push(this.getDefaultRow());
    },

    // 模拟图片选择（实际项目中替换为el-upload逻辑）
    selectImage(index) {
      // 这里仅做示例，实际需通过el-upload上传图片并获取URL
      this.formData.tableRows[index].imageUrl = "https://example.com/image.jpg";
    },

    // 提交表单（触发验证）
    handleSubmit() {
      this.$refs.deviceForm.validate((valid) => {
        if (valid) {
          this.$emit("submit", this.formData.tableRows);
          this.handleClose();
        } else {
          this.$message.error("请完善必填字段");
        }
      });
    },

    // 关闭弹窗
    handleClose() {
      // this.$refs.deviceForm.resetFields();
      this.$emit("update:visible", false);
      // this.formData.tableRows = [];
    },
  },
};
</script>

<style scoped lang="less">
/* 样式与之前保持一致，新增表单验证相关样式 */
.required {
  color: #f56c6c;
  margin-right: 2px;
  text-align: center;
}

.el-col {
  // text-align: center;
}
.table-header {
  font-weight: bold;
  padding: 10px 0;
  border-bottom: 1px solid #eaeaea;
  margin-bottom: 15px;
}

.table-body {
}

.table-row {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}

.image-preview {
  margin-top: 5px;
}

.dialog-footer {
  margin-top: 20px;
  text-align: right;
}

.is-required {
  margin: 0;
}
</style>
